import { useTranslationRef } from '@backstage/frontend-plugin-api';
import type { DoraRating } from '../../api/types';
import { doraMetricsTranslationRef } from '../../translation';
import { doraTheme } from '../theme';

const RATING_STYLES: Record<
  DoraRating,
  { background: string; color: string; border: string }
> = {
  elite: doraTheme.rating.elite,
  high: doraTheme.rating.high,
  medium: doraTheme.rating.medium,
  low: doraTheme.rating.low,
};

export function RatingBadge({ rating }: { rating: DoraRating }) {
  const s = RATING_STYLES[rating];
  const { t } = useTranslationRef(doraMetricsTranslationRef);

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: 9999,
        background: s.background,
        color: s.color,
        border: `1px solid ${s.border}`,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
      }}
    >
      {t(`rating.${rating}`)}
    </span>
  );
}
